import { useFlags } from 'launchdarkly-react-client-sdk';
import * as z from 'zod';

const releaseAssortmentBulkEditsSchema = z
  .object({
    skuLocationsTable: z.boolean(),
  })
  .passthrough();

export const useReleaseAsortmentBulkEdits = () => {
  const { releaseAssortmentSkuLocationsBulkEdits } = useFlags();
  return releaseAssortmentBulkEditsSchema.parse({
    skuLocationsTable: releaseAssortmentSkuLocationsBulkEdits,
  });
};
